import React, { useEffect, useMemo, useState } from 'react';
import { Box, Card, CardContent, Typography, CircularProgress, Alert } from '@mui/material';
import dayjs from 'dayjs';
import ReportDataService from '../../../services/report.service';
import { useTranslation } from '../../../hooks/useTranslation';

const PaymentsActiveMembershipsByMonthReport = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [rows, setRows] = useState([]);

  const range = useMemo(() => {
    const end = dayjs().startOf('month');
    const start = end.subtract(11, 'month');
    return { start, end };
  }, []);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setError('');
        const res = await ReportDataService.getPaymentsActiveMembershipsByMonth({
          start_month: range.start.format('YYYY-MM'),
          end_month: range.end.format('YYYY-MM'),
        });
        setRows(res.data?.data || []);
      } catch (e) {
        setError(e.response?.data?.message || t('reports.errorLoading'));
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [range, t]);

  const totalActiveThisMonth = rows?.length ? rows[rows.length - 1]?.count : 0;

  return (
    <Box>
      <Typography variant="h6" fontWeight={800} sx={{ mb: 1 }}>
        {t('reports.paymentsActiveMembershipsByMonth')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t('reports.paymentsActiveMembershipsByMonthDescription')}
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <Card variant="outlined">
        <CardContent>
          {loading ? (
            <Box display="flex" justifyContent="center" py={4}><CircularProgress /></Box>
          ) : (
            <>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {t('reports.activeMembershipsThisMonth', { count: totalActiveThisMonth })}
              </Typography>
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default PaymentsActiveMembershipsByMonthReport;

